export const CLOSE_PERSON_ENTRY = 'CLOSE_PERSON_ENTRY';
export const LOAD_ARLS = 'LOAD_ARLS';
export const LOAD_ADMINISTRATIVE_USERS = 'LOAD_ADMINISTRATIVE_USERS';
export const LOAD_ALERT_NOTIFICATIONS = 'LOAD_ALERT_NOTIFICATIONS';
export const LOAD_ANNOTATION_TYPES = 'LOAD_ANNOTATION_TYPES';
export const LOAD_CAPABILITIES = 'LOAD_CAPABILITIES';
export const LOAD_CITIES = 'LOAD_CITIES';
export const LOAD_CLIENTS = 'LOAD_CLIENTS';
export const LOAD_CLIENT_TYPES = 'LOAD_CLIENT_TYPES';
export const LOAD_EXECUTIVES = 'LOAD_EXECUTIVES';
export const LOAD_IDENTIFICATION_TYPES = 'LOAD_IDENTIFICATION_TYPES';
export const LOAD_ITEM_TYPES = 'LOAD_ITEM_TYPES';
export const LOAD_MAIL_TYPES = 'LOAD_MAIL_TYPES';
export const LOAD_MONTHS = 'LOAD_MONTHS';
export const LOAD_PASSENGER_TYPES = 'LOAD_PASSENGER_TYPES';
export const LOAD_PEOPLE = 'LOAD_PEOPLE';
export const LOAD_PETITION_STATUSES = 'LOAD_PETITION_STATUSES';
export const LOAD_PETITION_TYPES = 'LOAD_PETITION_TYPES';
export const LOAD_POSITIONS = 'LOAD_POSITIONS';
export const LOAD_PROFILES = 'LOAD_PROFILES';
export const LOAD_RESTRICTED_VISITORS = 'LOAD_RESTRICTED_VISITORS';
export const LOAD_STRUCTURE_TYPES = 'LOAD_STRUCTURE_TYPES';
export const LOAD_SUPERVISORS = 'LOAD_SUPERVISORS';
export const LOAD_TOOLS = 'LOAD_TOOLS';
export const LOAD_VALID_YEARS = 'LOAD_VALID_YEARS';
export const LOAD_VEHICLE_ENTRY_MASTER_DATA = 'LOAD_VEHICLE_ENTRY_MASTER_DATA';
export const LOAD_VEHICLE_TYPES = 'LOAD_VEHICLE_TYPES';
export const LOAD_VENUE_PEOPLE_BY_STRUCTURE = 'LOAD_VENUE_PEOPLE_BY_STRUCTURE';
export const LOAD_VISITOR_TYPES = 'LOAD_VISITOR_TYPES';